module.exports = __webpack_public_path__ + "img/PDAC1_Treg.18d1d041.png";